module.exports = __webpack_public_path__ + "static/media/bell-hand3.2d045394.aac";